import type { Map } from 'immutable';
import { createSelector } from 'reselect';

import { initialState } from './reducer';
import type { LanguageState } from './reducer';

export type LanguageRootState = Map<string, LanguageState>;

/**
 * Direct selector to the languageToggle state domain
 */

const selectLanguage = (state: LanguageRootState): LanguageState =>
  state.get('language') || initialState;

/**
 * Select the language locale
 */

const makeSelectLocale = () =>
  createSelector(selectLanguage, (languageState: LanguageState) =>
    languageState.get('locale'),
  );

export { selectLanguage, makeSelectLocale };
